import React from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import { withEventScope } from '@repo/event-processor';
import { Button, secondaryTheme } from '@repo/ui/components/Buttons';
import { Spacer } from '@repo/ui/components/Spacer';
import { themeStyle } from '@repo/ui/theming';

import {
  ResponsiveHeader,
  ResponsiveText,
  ResponsiveButtonsWrapper,
} from '../styles';

import {
  ShowcaseItemWrapper,
  ShowcaseResponsiveImage,
  ShowcaseTitle,
  ShowcaseDescription,
} from './styles';
import { ShowcaseContentProps } from './types';

const ShowcaseContent: React.FC<ShowcaseContentProps> = ({
  heading,
  subheading,
  showcaseItems,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <>
      <ResponsiveHeader
        style={{ textAlign: 'center', wordBreak: 'break-word' }}
      >
        {heading}
      </ResponsiveHeader>
      {subheading && (
        <ResponsiveText style={{ marginTop: '12px', textAlign: 'center' }}>
          {subheading}
        </ResponsiveText>
      )}
      <Spacer height="24px" />
      <FlexColumn gap="8px">
        {showcaseItems.map((item) => (
          <a
            key={item.heading}
            href={item.href}
            rel="noreferrer"
            style={{ textDecoration: 'none' }}
            target="_blank"
          >
            <ShowcaseItemWrapper>
              <ShowcaseResponsiveImage alt={item.heading} src={item.imgSrc} />
              <FlexColumn gap="8px">
                <ShowcaseTitle style={{ fontWeight: themeStyle.fontExtraBold }}>
                  {item.heading}
                </ShowcaseTitle>
                <ShowcaseDescription color={themeStyle.varInkMedium}>
                  {item.description}
                </ShowcaseDescription>
              </FlexColumn>
            </ShowcaseItemWrapper>
          </a>
        ))}
      </FlexColumn>
      <Spacer height="24px" />
      <ResponsiveButtonsWrapper>
        {secondaryButton && (
          <Button
            label={secondaryButton.label}
            name="cancelOffboardingButton"
            theme={secondaryTheme}
            width="100%"
            onClick={secondaryButton.onClick}
          />
        )}
        <Button name="showcasePrimaryButton" width="100%" {...primaryButton} />
      </ResponsiveButtonsWrapper>
    </>
  );
};

export default withEventScope(ShowcaseContent, { module: 'showcaseContent' });
